module.exports = __webpack_public_path__ + "static/img/brief-ction3.ab21b52.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/brief-ction3.jpg
// module id = /A08
// module chunks = 1